<script setup>
import HomePage from '~/components/home/HomePage.vue'

definePageMeta({
  layout: 'dashboard',
  middleware: 'auth',
  ssr: false,
})

useHead({
  title: 'Hem',
})
</script>

<template>
  <HomePage />
</template>
